import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import type { EvCalculationResponse } from '@//app/api/ev-calculation/[id]';
import { httpClientGetJson } from '../httpClient';

const EV_CHARCING_COST_PER_KILOMETER_CACHE_KEY = 'api/ev-calculation/:id';

export interface UseEvCharchingCostPerKilometerVariables {
  id: string;
  kwhCost?: number;
}

const useEvCharchingCostPerKilometer = ({
  id,
  kwhCost,
}: UseEvCharchingCostPerKilometerVariables) => {
  const queryClient = useQueryClient();
  const query = useQuery<EvCalculationResponse>({
    queryKey: [EV_CHARCING_COST_PER_KILOMETER_CACHE_KEY, id, kwhCost],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (kwhCost) {
        params.set('kwhCost', kwhCost.toString());
      }
      const queryString = params.toString() ? `?${params.toString()}` : '';
      const url = `/api/ev-calculation/${id}${queryString}`;
      return await httpClientGetJson<EvCalculationResponse>(url);
    },
    enabled: !!id,
    retry: false,
  });

  useEffect(() => {
    const kwhCostFromResponse = query.data?.description.costPerKwh.value;
    if (query.data && kwhCost === undefined && kwhCostFromResponse !== undefined) {
      queryClient.setQueryData<EvCalculationResponse>(
        [EV_CHARCING_COST_PER_KILOMETER_CACHE_KEY, id, kwhCostFromResponse],
        query.data,
      );
      queryClient.setQueryData<EvCalculationResponse>(
        [EV_CHARCING_COST_PER_KILOMETER_CACHE_KEY, id, 0],
        query.data,
      );
    }
  }, [query.data, kwhCost]);

  return query;
};

export default useEvCharchingCostPerKilometer;
